// extracted by mini-css-extract-plugin
export default {"titleCell":"gVtf0","titleInner":"p3mpb","subtitle":"f634C","authorsCell":"md6Ux","authors":"HWfxr","authorTrigger":"hEZDp","statusCell":"rcuV4","schoolCell":"SoBdW"};